import React, { useState, useEffect } from "react";
import { IconButton, Menu, MenuItem, Typography, Badge, Divider } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import api_client from "../../Authentication/axiosConfig";

const CategoryFilterMenu = ({ filters, setFilters, fetchData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [categories, setCategories] = useState([]);
    const isActive = !!filters.category;
    
    useEffect(() => {
        // Fetch distinct categories
        const fetchCategories = async () => {
            try {
                // This is a simplified approach - in a production environment,
                // you would want a dedicated endpoint for this
                const response = await api_client.get("/list_news/", { 
                    params: { page: 1, page_size: 100 } 
                });
                
                if (response.data && response.data.results) {
                    const allCategories = response.data.results.map(item => item.category);
                    setCategories([...new Set(allCategories)].filter(Boolean).sort());
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
        
        fetchCategories();
    }, []);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleCategoryFilter = (category) => {
        const newFilters = { ...filters, category };
        setFilters(newFilters);
        handleMenuClose();
        fetchData(newFilters);
    };
    
    const clearCategoryFilter = () => {
        const { category, ...restFilters } = filters;
        setFilters(restFilters);
        handleMenuClose();
        fetchData(restFilters);
    };
    
    return (
        <div>
            <Badge 
                color="primary" 
                variant="dot" 
                invisible={!isActive}
                overlap="circular"
            >
                <IconButton 
                    onClick={handleMenuClick} 
                    title="Filter by category"
                    color={isActive ? "primary" : "default"}
                >
                    <CategoryIcon />
                </IconButton>
            </Badge>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                    style: {
                        borderRadius: "8px",
                        marginTop: "8px",
                        maxHeight: "400px",
                        width: "200px",
                    },
                }}
            >
                <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                    Filter by Category
                </Typography>
                
                {isActive && (
                    <Typography variant="body2" sx={{ px: 2, pb: 1, fontSize: '0.8rem', color: 'primary.main' }}>
                        Active: {filters.category}
                    </Typography>
                )}
                
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {categories.map(category => (
                        <MenuItem 
                            key={category} 
                            onClick={() => handleCategoryFilter(category)}
                            className="px-3 py-2"
                            selected={filters.category === category}
                        >
                            {category}
                        </MenuItem>
                    ))}
                </div>
                
                <Divider sx={{ my: 1 }} />
                
                <MenuItem 
                    onClick={clearCategoryFilter}
                    className="px-3 py-2"
                    disabled={!isActive}
                >
                    <Typography color={isActive ? "error" : "text.disabled"}>
                        {isActive ? "Clear Category Filter" : "No Category Filter Applied"}
                    </Typography>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default CategoryFilterMenu;
